// extracted by mini-css-extract-plugin
module.exports = {"root":"sortItem_root__3fNLu","content":"sortItem_content__RfLmN","text":"sortItem_text__LysTn"};